<template>
  <v-container class="step" :style="`background-color:${color}; width:${width}`">
    <v-row no-gutters class="justify-between pa-3">
      <v-col>{{text}}</v-col>
      <v-col class="text-right">{{qtd}}</v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false
    },
    qtd: {
      type: Number | String,
      required: false,
      default: '?'
    },
    color: {
      type: String,
      required: false,
      default: 'palevioletred'
    },
    width: {
      type: String,
      required: false,
      default: '100%'
    }
  }
};
</script>

<style scoped>
.step {
  color: white;
  font-weight: bold;
  float: none;
  font-size: 13px;
  padding: 6px;
  height: auto;
  -moz-border-radius: 100px;
  border-radius: 100px;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

@media only screen and (min-width: 576px) {
  .step {
    font-size: 17px;
    padding: 20px;
  }
}
</style>